
















import {Component, Prop, Mixins} from 'vue-property-decorator'
import {INewsData,IBeautyPlaceData} from '@/entities'

@Component
export default class NewsPreviewCard extends Mixins() {

  @Prop() readonly newsData?: INewsData
  @Prop() readonly placeData?: IBeautyPlaceData
  @Prop() readonly index?: number

  get news(): INewsData | null | undefined {
    return this.newsData;
  }
  get place(): IBeautyPlaceData | null | undefined{
    return this.placeData;
  }
  get IsPlace(): boolean {
      return this.place !== undefined;
  }
  get title(): string | undefined{
       if (this.IsPlace) {
          return this.place?.title;
      }
      else return this.news?.title;
  }
  get url(): string | undefined {
    if(this.IsPlace) {
          return this.place?.images?.find((_,i)=>i === 0)
    }
    else return `${process.env.VUE_APP_BASE_URL}/media/news_temps/${this.index}.png`;
  }

  get Id():number | undefined {
     if (this.IsPlace) {
          return this.place?.id;
      }
      else return this.news?.id;
  }
}
